import {i18nKey} from '@/locales/i18n';
import IconDelete from '@/assets/icons/ic_delete.svg';
import IconEdit from '@/assets/icons/ic_edit_gray.svg';
import IconView from '@/assets/icons/ic_view.svg';

export enum USER_FORM {
  SEARCH = 'search',
  STATUS = 'status',
  DEPARTMENT = 'department',
  CREATED_DATE = 'createdDate',
}

export enum USER_FORM_COMPONENT {
  EMAIL = 'email',
  PASSWORD = 'password',
  STAFF_NAME = 'staffName',
  DEPARTMENT = 'department',
  PHONE = 'phone',
  DESCRIPTION = 'description',
  BLOCK_LIMIT = 'blockLimit',
  EXPIRY_DATE = 'expiryDate',
  STATUS = 'status',
}

export const LIST_STATUS = [
  {
    value: 1,
    label: () => i18nKey.userScreen.formFilter.status.all,
  },
  {
    value: 2,
    label: () => i18nKey.userScreen.formFilter.status.active,
  },
  {
    value: 3,
    label: () => i18nKey.userScreen.formFilter.status.deactivate,
  },
];

export const LIST_DEPARTMENT = [
  {value: '1', label: () => i18nKey.userScreen.formFilter.department.all},
  {value: '2', label: () => i18nKey.userScreen.formFilter.department.all},
  {
    value: '3',
    label: () => i18nKey.userScreen.formFilter.department.all,
  },
];

export enum MENU_KEY_USER {
  detail = '1',
  edit = '2',
  delete = '3',
}

export const ITEM_ACTION_USER = [
  {
    key: '1',
    label: () => i18nKey.templateScreen.listTemplate.actionText.view,
    icon: IconView,
  },
  {
    key: '2',
    label: () => i18nKey.templateScreen.listTemplate.actionText.edit,
    icon: IconEdit,
  },
  {
    key: '3',
    label: () => i18nKey.templateScreen.listTemplate.actionText.delete,
    icon: IconDelete,
  },
];
